<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <!-- <b-navbar
      class="formCard"
      style="border-radius: 5px !important; padding-left: 0px"
      toggleable="lg"
      type="dark"
      variant="primary"
    >
      <b-navbar-brand center
        >Assignment Summary & Documents - {{ JOBSERIES }}
      </b-navbar-brand> -->
    <!-- <b-button class="pull-right ml-5"  size="sm"  @click="downloadDocs">Download Docs</b-button> -->
    <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-form-input :formatter="capitalizeAll"
                class="mr-sm-2"
                v-model="filter"
                @input="viewFFExportFCL('0','1')"
                placeholder="Search"
              ></b-form-input>
          
            </b-nav-form>
          </b-navbar-nav>-->
    <!-- </b-navbar> -->
    <b-button style="font-size: 0.675rem" size="sm" class="text-left" :variant="'info'"
      @click="ActiveAccordion(ContainerActiveStatus)">Show Cont.</b-button>
    <b-button style="font-size: 0.675rem" size="sm" class="text-left" :variant="'info'"
      @click="ActiveTimelineAccordion(assActiveStatus)">Timeline</b-button>
    <b-button size="sm"
    
    v-if="($sessionsStorage.get('designation') == 'Admin' &&
        $sessionsStorage.get('nameUser') == 'Bhavneesh')"
    :disabled="
        extra_payment_flag == true &&
        $sessionsStorage.get('designation') != 'Admin' &&
        $sessionsStorage.get('nameUser') != 'Bhavneesh'
          ? true
          : false
      " variant="outline-primary" class="m-1" @click="addExpense('')">Add / View Expenses</b-button>
      <b-button size="sm"  :disabled="
        extra_payment_flag == true &&
        $sessionsStorage.get('designation') != 'Admin' &&
        $sessionsStorage.get('nameUser') != 'Bhavneesh'
          ? true
          : false
      " 
      variant="outline-primary" class="m-1" @click="addExpense('Lite')">Add Expenses New</b-button>
    <b-button 
    
    v-if="($sessionsStorage.get('designation') == 'Admin' &&
        $sessionsStorage.get('nameUser') == 'Bhavneesh')"
    size="sm" 
    :disabled="
        extra_payment_flag == true &&
        $sessionsStorage.get('designation') != 'Admin' &&
        $sessionsStorage.get('nameUser') != 'Bhavneesh'
          ? true
          : false
      " variant="outline-primary" class="m-1" @click="addAdditionalTask('')">Add Additional Task Request</b-button>
      <b-button size="sm"  :disabled="
        extra_payment_flag == true &&
        $sessionsStorage.get('designation') != 'Admin' &&
        $sessionsStorage.get('nameUser') != 'Bhavneesh'
          ? true
          : false
      " variant="outline-primary" class="m-1" @click="addAdditionalTask('Lite')">Additional Task(New)</b-button>
    <b-button v-if="enq_doc_master.length>0" size="sm" :disabled="
        $sessionsStorage.get('designation') != 'Admin' &&
        $sessionsStorage.get('nameUser') != 'Bhavneesh'
          ? true
          : false
      " variant="outline-primary" class="m-1" @click="showEnqDoc(showEnquiryTable)">
      Show Enquiry Documents
    </b-button>
    <!-- <b-button
      style="font-size: 0.675rem margin-left: 5px"
      @click="showQuotation"
      size="sm"
      class="mt-1"
      variant="outline-primary"
  >Show Quotation</b-button> -->
    <!-- <Quotation-Summary :QT_modal_show="showQuotationModal" :QT_fk_all_module_id="allModuleIdProp" :QT_jb_series="JOBSERIES" /> -->

    <!-- <b-button v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" size="sm" variant="outline-primary" class="m-1"  @click="addExpense">Add / View Expenses New</b-button> -->
    <!-- <b-button v-b-toggle.collapse-2 size="sm" variant="outline-primary" class="m-1">Add Additional Task Request</b-button> -->
    <!-- <b-button v-b-toggle.collapse-2 size="sm" variant="outline-primary" class="m-1">Add / View Expenses</b-button> -->

    <Add-Message :fk_all_module_id="allModuleIdProp" class="pull-right" style="list-style-type: none" />
    <Assignment-Timeline :TMAccordianStatus="false" :TMAccordianButton="true" v-if="assActiveStatus"
      :allModuleId="Number(allModuleIdProp)" />
    <!-- Element to collapse -->
    <b-card v-if="ContainerActiveStatus">
      <table class="table table-sm table-bordered">
        <tbody>
          <tr>
            <th scope="col">SN.</th>
            <th scope="col">Container Type</th>
            <th scope="col">Container No</th>
            <th scope="col">Description</th>
          </tr>
          <tr v-for="(itm, idx) in splitMergeContainerDetails" :key="idx">
            <th style="text-align: center; vertical-align: middle; width: 20px" bgcolor="whiteSmoke" scope="row">
              {{ parseInt(idx + 1) }}
            </th>
            <td>{{ itm.containerType }}</td>
            <td>{{ itm.containerNo }}</td>
            <td>
              <span v-if="itm.splitedToOrMergedToAssigNo" class="error">
                Container Moved From :{{ itm.fromSplitMergeAssignNo }} to :
                {{ itm.splitedToOrMergedToAssigNo }} (
                <b v-if="itm.isSplitedOrMergedNew == 1">Splited</b>
                <b v-else-if="itm.isSplitedOrMergedNew == 2">Merged</b>
                <b v-else-if="itm.isSplitedOrMergedNew == 3">Moved</b>
                ) Updated Date({{ itm.split_merge_date_time }})
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <b-collapse id="collapse-2">
      <table class="table table-sm table-bordered">
        <tbody style="background: white">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Particulars</th>
            <th scope="col">Amount</th>
            <th scope="col">Remarks</th>
            <th scope="col"></th>
          </tr>
          <tr v-for="(item, idx) in otherExpense" :key="idx">
            <th scope="row">{{ idx + 1 }}</th>
            <td>
              <model-list-select :list="ledgerData" v-model="item.ledgerId" option-value="ledgerId" option-text="ledger"
                placeholder="Select "></model-list-select>
              <!-- <span class="error" v-if="!AdditionalTask.ledgerId">{{errorAdditionalTask.ledgerId}}</span> -->
            </td>
            <td>
              <b-form-input :formatter="capitalizeAll" id="amount" name="amount" v-model="item.amount"></b-form-input>
              <!-- <span class="error" v-if="!AdditionalTask.ledgerId">{{errorAdditionalTask.ledgerId}}</span> -->
            </td>
            <td>
              <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark"
                v-model="item.remark"></b-form-textarea>
            </td>
            <td>
              <b-button v-if="!item.expenseId" class="mt-3" size="sm" @click="addExpenses(item)" variant="primary">Add
                Expense</b-button>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </b-collapse>
    <b-row class="mt-3">
      <b-col cols="12" v-if="showEnquiryTable"><b>Enq Documents - ENQ NO : {{ enq_no }}</b>
        <div style="width: 100%" class="table">
          <table class="table table-sm table-bordered">
            <thead></thead>
            <tbody>
              <tr>
                <th scope="col" style="width: 10px">SN.</th>
                <th scope="col">Name</th>
                <th scope="col" style="width: 170">View</th>
                <th scope="col">Remarks</th>
              </tr>
              <tr v-for="(doc_item, doc_ind) in enq_doc_master" :key="doc_ind">
                <th scope="row">{{ doc_ind + 1 }}</th>
                <th scope="row">{{ doc_item.doc_name }}<br />
                  <span class="error" v-if="doc_item.doc_created_date">
                    Added on {{ doc_item.doc_created_date }}</span><br /><span class="error"
                    v-if="doc_item.createdBy || doc_item.updatedBy">
                    Created/Updated By
                    {{ doc_item.createdBy ? doc_item.createdBy : doc_item.updatedBy }}</span>
                </th>
                <th>
                  <div v-if="doc_item.doc_url">
                    <span v-for="(item1, index1) in doc_item.doc_url.split(',')" :key="index1">
                      <a v-if="!doc_item.doc_url.includes('upload_pic')" href="javascript:void(0)" @click.prevent="openSignedDocument('ASSIGNMENT_UPLOADS/' + enq_no.replaceAll('/', '_') + '/' + item1)">View Document - {{ index1 + 1 }} <br /></a>
                      <a v-else :href="`${docURL}/` + item1" target="_blank" download>View Document - {{ index1 + 1 }}
                        <br /></a>
                    </span>
                  </div>
                </th>
                <th scope="row">{{ doc_item.doc_remark }}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
      <b-col cols="4"><b>Summary</b>
        <br />
        <div class="table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-bordered">
            <tbody>
              <tr v-for="(item, index) in showSumaryArray" :key="index">
                <td>{{ item.name }}</td>
                <td>
                  <span v-html="item.value">{{ item.value }} Test</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
      <!-- <b-button size="sm" @click="downloadZip" variant="outline-info">Download Zip</b-button> -->
      <!-- this.enq_no = data.enq_no;
              this.enq_doc_master  -->

      <b-col cols="8"><b>Documents</b>

        <b-button class="pull-right mb-2" size="sm" @click="downloadZip" variant="outline-info">Download Zip</b-button>
        <div style="width: 100%" class="table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-sm table-bordered">
            <thead></thead>
            <tbody>
              <tr>
                <th scope="col" style="width: 10px">
                  <b-button :disabled="(accountFlag?false:(extra_payment_flag == true && $sessionsStorage.get('designation') != 'Admin' &&$sessionsStorage.get('nameUser') != 'Bhavneesh'? true: false))" v-if="showAdd == true" size="sm" variant="outline-dark" @click="addMoreDoc">Add</b-button>
                </th>
                <th scope="col">Name</th>
                <th scope="col" style="width: 170">View</th>
                <th scope="col">Remarks</th>
                <!-- <th scope="col">Handle</th> -->
              </tr>
              <!-- {{docArray}} -->
              <tr v-for="(item, index) in docArray" :key="index">
                <th scope="row">
                  {{ index + 1 }}
                  <b-button v-if="
                      item.item != '' &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                    " size="sm" variant="outline-dark" @click="removeDoc(item)">Remove</b-button>
                </th>

                <td>
                  <model-list-select :list="doc_master" id="clientNamenew" v-model="item.documentName"
                    option-value="d_name" option-text="d_name" placeholder="Select"></model-list-select><span
                    class="error" v-if="item.docAddedDate">
                    Added on {{ item.docAddedDate }}</span><br /><span class="error"
                    v-if="item.createdBy || item.updatedBy">
                    Created/Updated By
                    {{ item.createdBy ? item.createdBy : item.updatedBy }}</span><br /><b-form-input
                    :formatter="capitalizeAll" v-if="item.documentName == 'Other'"
                    :disabled="item.addedFromMain == '0' ? true : false" v-model="item.otherDocName"></b-form-input>
                </td>
                <td>
                  <div v-if="item.documentLink && item.addedFromMain == '0'">
                    <span v-for="(item1, index1) in item.documentLink.split(',')" :key="index1">
                      <a v-if="!item.documentLink.includes('upload_pic')" href="javascript:void(0)" @click.prevent="openSignedDocument('ASSIGNMENT_UPLOADS/' + JOBSERIES.replaceAll('/', '_') + '/' + item1)">View Document - {{ index1 + 1 }} <br /></a>
                      <a v-else :href="`${docURL}/` + item1" target="_blank" download>View Document - {{ index1 + 1 }}
                        <br /></a>
                    </span>
                  </div>
                  <div v-else-if="item.addedFromMain == '1'">
                <td>
                  <div>
                    <span class="error" v-if="doc_err">{{doc_err}}</span>
                    <!-- Styled -->
                    <!-- <b-form-file
      style="height: 79px;    background: darkgray;    width: 300px;"
      v-if="!item.doc_id"
      :multiple="true"
      v-model="singleUpload"
      :state="Boolean(singleUpload)"
      placeholder="Choose a file or drop it here..."
      drop-placeholder="Drop file here..."
      plain
    ></b-form-file> -->
                    <multi-file-uploader :style="`height: 79px;    background: darkgray;    width: 300px;`"
                      v-if="!item.doc_id" :documentName="'Doc-'" :otherDocName="'Doc-'" :folderName="'Doc Library'"
                      :accept="'*'" :assign_no="JOBSERIES" :multiple="true" v-model="singleUpload"
                      :state="Boolean(singleUpload)" :fileAllModuleId="allModuleIdProp"></multi-file-uploader>
                    <span v-if="!item.doc_id">Choose a file or drop it above...</span>
                    <!-- 

    <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
    <div class="mt-3">Selected file: {{ file2 ? file2.name : '' }}</div> -->
                  </div>

                  <!-- <b-form-file
   v-if="!item.doc_id"
      v-model="singleUpload"
     multiple
      placeholder="Choose a file ..."
        
    ></b-form-file> -->

                  <!-- <md-input-container
                        v-if="!item.doc_id"
                        style="margin: 0px !important"
                      >
                        <md-file
                          name="invoiceUpload"
                          id="invoiceUpload"
                          multiple
                          v-model="singleUpload"
                          @selected="onFileChange(index, item)"
                        ></md-file>
                      </md-input-container>   -->
                  <div v-if="item.documentLink">
                    <span v-for="(item1, index1) in item.documentLink.split(',')" :key="index1">
                      <a href="javascript:void(0)" @click.prevent="openSignedDocument('ASSIGNMENT_UPLOADS/' + JOBSERIES.replaceAll('/', '_') + '/' + item1)">View {{ item1 }} - {{ index1 + 1 }} <br /></a>
                    </span>
                  </div>
                </td>
        </div>

        <!-- <a
                            :href="
                              `${docURL}/FF_Sea_Export_Uploads/` +
                              item
                            "
                            target="_blank"
                            download
                            >View Document - {{ index + 1 }}</a
                          >
{{item.documentLink}} -->
        </td>
        <td>
          <b-form-textarea :formatter="capitalizeAll" :disabled="item.addedFromMain == '0' ? true : false"
            v-model="item.docRemarks"></b-form-textarea><b-button class="pull-right mt-2"
            v-if="item.addedFromMain == '1' && !item.doc_id" size="sm" variant="outline-dark"
            @click="submitDocment(index, item)">Upload</b-button>
        </td>
        </tr>
        </tbody>
        </table>
  </div>
  </b-col>
  </b-row>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC, URL_NODE_BASE } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import AddMessage from "../allModuleForm/addMessage.vue";
// import QuotationSummary from "../common/quotationSummary.vue";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import ClientUserService from "../../services/ClientUserService.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import AssignmentTimeline from "../common/assignmentTimeline.vue";

export default {
  props: ["allModuleIdProp", "JOBSERIES"],
  beforeMount() {
    this.$sessionsStorage.set("allModuleIdMain", "");
    this.$sessionsStorage.set("JOBSERIES", "");
    this.$sessionsStorage.set("allModuleIdMain", this.allModuleIdProp);
    this.$sessionsStorage.set("JOBSERIES", this.JOBSERIES);
    if (this.allModuleIdProp) {
      this.getData();
    } else {
      // this.$router.push({
      //   path: "/dashboard",
      // });
    }
  },

  data() {
    return {
      accountFlag:globalPermissionStatus('Accounts'),
      doc_err: '',
      assActiveStatus: false,
      ContainerActiveStatus: false,
      splitMergeContainerDetails: [],
      extra_payment_flag: false,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      isLoading: false,
      docArray: [],
      enq_doc_master: [],
      showEnquiryTable: false,
      enq_no: "",
      showSumaryArray: [],
      otherExpense: [],
      doc_master: [],
      docURL: URL_BASE_DOC,
      singleUpload: [],

      showAdd: true,

      allModuleId: this.allModuleIdProp,
      showQuotationModal: false,
    };
  },

  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.singleUpload = file;
    });
  },
  //this.$route.params.moduleId?this.$route.params.moduleId:
  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    AddMessage,
    MultiFileUploader,
    AssignmentTimeline,
    // QuotationSummary,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    ActiveTimelineAccordion(ActiveStatus) {
      if (ActiveStatus == true) {
        this.assActiveStatus = false;
      } else if (ActiveStatus == false) {
        this.assActiveStatus = true;
      }
    },
    ActiveAccordion(ActiveStatus) {
      if (ActiveStatus == true) {
        this.ContainerActiveStatus = false;
      } else if (ActiveStatus == false) {
        this.ContainerActiveStatus = true;
      }
      this.splitMergeContainerDetails = this.$store.getters[
        "common/getAllSplitedOrMergedContainersList"
      ];
    },
    // showQuotation() {
    //   this.showQuotationModal = !this.showQuotationModal
    // },
    addExpense(type) {
      this.$sessionsStorage.set("exp_id", "");
      // alert(this.$sessionsStorage.get("exp_id"));
      this.$router.push({
        path: `/allModule/Expenses${type}`,
      });
    },
    addAdditionalTask(type) {
      // this.$sessionsStorage.set("additional_Task_id",'');
      this.$router.push({
        path: `/allModule/AdditionalTask${type}`,
      });
    },
    showEnqDoc(ActiveStatus) {

      if (ActiveStatus == true) {
        this.showEnquiryTable = false;
      } else if (ActiveStatus == false) {
        this.showEnquiryTable = true;
      }
    },
    removeDoc(item, index) {
      // console.log("Priyanshu SIngh=>",item);return false;
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isDocActive = this.itemObj.isDocActive == "1" ? 0 : 1;
      let paylod = {
        tableName: "assignment_uploads",
        tableId: "doc_id",
        tableIsActive: "isDocActive",
        value1: this.itemObj.isDocActive,
        tableVal: item.doc_id,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    removeDocBak(item) {
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Expenses/deleteUploadExpenses.php`,
        data: JSON.stringify(item),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (data) {
            this.getData();
          }
        })
        .catch((error) => {});
    },
    addExpenses(item) {
      item["allModuleId"] = this.allModuleIdProp;

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/addAllExpense_NewV3_VP.php`,
        // url: `${URL_BASE}/Enquiry/addAllExpense_NewV3.php`,
        data: JSON.stringify(item),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json,multipart/form-data",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (data) {
            this.getData();
          }
        })
        .catch((error) => {});
    },
    downloadZip() {
      let payload = {
        upload_dir_folderName: this.JOBSERIES.replaceAll("/", "_"),
      };
      NodeLockPannelService.downloadAssignmentZipNode(payload)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${payload.upload_dir_folderName}.zip`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error("Download Error:", error);
        });
    },
    downloadDocs(url, filename) {
      fetch(url).then(function (t) {
        return t.blob().then((b) => {
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", filename);
          a.click();
        });
      });
    },
    submitDocment(index, item) {
      let splitAssignMentId = "";
      // let NewItem = {};
      // item.forEach((element) => {
      console.log("item happy Sinngh=>", item,this.singleUpload);
      
      let doc = this.singleUpload.split(',');
      console.log("doc=>",doc,this.singleUpload);
      let  AssDoc = doc.indexOf('Array')>=0 || doc.indexOf('')>=0;
      if(AssDoc){
        this.doc_err = "Document Upload Failed. Pls Re-Upload Document Now";
        console.log("Wrong Doc");
        return false;
      }else{
        this.doc_err = "";
        console.log("Right Doc");
      }
      // return false
      let obj = {
        documentName: item.documentName,
        otherDocName: item.otherDocName,
        documentLink: this.singleUpload,
        singleUpload: this.singleUpload,
        docRemarks: item.docRemarks,
        addedFromMain: "1",
        allModuleId: this.allModuleIdProp,
      };
      // NewItem = obj;
      //   NewItem.push(obj);
      // });
      console.log("obj happy Sinngh=>", obj);

      if (this.JOBSERIES) {
        let abc = this.JOBSERIES.split("/");
        if (abc.length > 0) {
          item["splitAssignMentId"] = abc[5];
        }
      }
      this.showAdd = true;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/addModuleDocLibrary_NewV3.php`,
        data: obj,
        // data: JSON.stringify(NewItem),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json,multipart/form-data",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (data) {
            this.singleUpload = [];
            this.getData();
          }
        })
        .catch((error) => {});
    },
    addMoreDoc() {
      this.showAdd = false;
      let obj = {
        documentName: "",
        documentLink: "",
        docRemarks: "",
        addedFromMain: "1",
        allModuleId: this.allModuleIdProp,
      };

      //this.$route.params.moduleId?this.$route.params.moduleId:
      this.docArray.push(obj);
      this.docArray.reverse();
    },
    onFileChange(index, item) {
      this.isLoading = true;
      // var files =Object.assign({}, this.singleUpload);
      var files = this.singleUpload;

      // var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "staticFileName",
          "Doc-" + item.documentName + this.docArray.length
        );
        formData.append(
          "upload_dir_folderName",
          this.JOBSERIES.replaceAll("/", "_")
          // this.mainEntryData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          this.docArray[index].singleUpload = result.data;
          this.isLoading = false;
          this.submitDocment(item);
        })
        .catch((err) => {
          throw err;
        });
    },
    getData() {
      this.assActiveStatus = false;
      this.ContainerActiveStatus = false;
      this.showEnquiryTable = false;

      let splitAssignMentId = "";
      if (this.JOBSERIES) {
        let abc = this.JOBSERIES.split("/");
        if (abc.length > 0) {
          splitAssignMentId = abc[5];
        }
      }
      this.showAdd = true;
      this.isLoading = true;
      this.docArray = [];
      this.otherExpense = [];
      this.ledgerData = [];
      this.showSumaryArray = [];
      this.enq_doc_master = [];
      this.enq_no = "";
      let payload = {
        allModuleId: this.allModuleIdProp,
        splitAssignMentId: splitAssignMentId,
      };

      this.$store.dispatch(
        "common/setAllSplitedOrMergedContainersList",
        JSON.stringify({
          itemCode: "SplitedOrMergedContainersList",
          allModuleId: this.allModuleIdProp,
        })
      );

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getAllConDocs_NewV3_test.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "iuyiu");
            // alert(data.extra_payment_flag);
            if (data.docArray.length > 0) {
              this.docArray = data.docArray;
            }
            this.enq_no = data.enq_no;
            if (data.enq_doc_master.length > 0) {
              this.enq_doc_master = data.enq_doc_master;
            }

            this.extra_payment_flag = data.extra_payment_flag;

            if (data.doc_master.length > 0) {
              this.doc_master = data.doc_master;
            }
            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            }
            if (data.otherExpense.length > 0) {
              this.otherExpense = data.otherExpense;
            }

            let obj = {
              ledgerId: "",
              amount: "",
              remark: "",
            };

            this.otherExpense.push(obj);
            if (data.mainExecData.length > 0) {
              if (
                data.mainExecData[0].transportType == "Export" &&
                data.mainExecData[0].shipmentType == "1" &&
                data.mainExecData[0].newContainerFlow == "0"
              ) {
                var p = data.FFSumary[0];
                for (var key in p) {
                  if (p.hasOwnProperty(key)) {
                    let obj = {
                      name: key,
                      value: p[key] ? p[key] : "--",
                    };
                    this.showSumaryArray.push(obj);
                  }
                }
                var q = data.CCSumary[0];
                for (var key in q) {
                  if (
                    q.hasOwnProperty(key) &&
                    !this.showSumaryArray.hasOwnProperty(key)
                  ) {
                    let obj = {
                      name: key,
                      value: q[key] ? q[key] : "--",
                    };
                    this.showSumaryArray.push(obj);
                  }
                }
                function getUniqueListBy(arr, key) {
                  return [...new Map(arr.map((item) => [item[key], item])).values()];
                }
                this.showSumaryArray = getUniqueListBy(this.showSumaryArray, "name");

                console.log(this.showSumaryArray);
              }

              var p = data.mainExecData[0];
              for (var key in p) {
                if (p.hasOwnProperty(key) && p[key]) {
                  let obj = {
                    name: key,
                    value: p[key] ? p[key] : "--",
                  };
                  this.showSumaryArray.push(obj);
                }
              }
            }
             this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// docLibrary.vue?3da73216